/**
 * ens-cart-feedback.js
 *
 * Unified "Added to cart" notification for all add-to-cart paths:
 *   1. Globo Product Options AJAX  — bypasses the theme's native form-submit listener
 *   2. Native Shopify product form — handled by AjaxCart or the theme.liquid fallback;
 *      the fallback must not repost submits already handled by AjaxCart/Globo.
 *   3. Collection quick-add (Shopify.addItem / XHR) — already shows theme.alert in
 *      theme.js; XHR interception below silently deduplicates if both fire together.
 *
 * Cart-drawer mode: when .js-mini-cart has data-cartmini="true" the store uses a
 * slide-in drawer as feedback, so toast notifications are suppressed (matching the
 * existing theme behaviour for quick-add and AjaxCart).
 */

(function () {
  'use strict';

  /* ── helpers ── */

  var _lastNotify = 0;
  var DEDUP_MS = 400; // block duplicates within this window

  function _isDrawerMode() {
    var el = document.querySelector('.js-mini-cart');
    return el && el.getAttribute('data-cartmini') === 'true';
  }

  function _updateMiniCart() {
    if (typeof theme !== 'undefined' && theme.miniCart) {
      if (typeof theme.miniCart.generateCart === 'function') theme.miniCart.generateCart();
      if (typeof theme.miniCart.updateElements === 'function') theme.miniCart.updateElements();
    }
  }

  function _buildMessage(title, imgUrl, qty) {
    var img = imgUrl
      ? '<img class="ens-cart-toast__image" src="' + imgUrl + '" width="72" height="72" alt="" />'
      : '<span class="ens-cart-toast__image ens-cart-toast__image--empty" aria-hidden="true"></span>';
    var qtyPart = qty && qty > 1 ? '<span class="ens-cart-toast__qty">Qty: ' + qty + '</span>' : '';
    return '<div class="alert--cart ens-cart-toast">'
      + '<div class="ens-cart-toast__media">' + img + '</div>'
      + '<div class="ens-cart-toast__body"><strong class="ens-cart-toast__title">' + (title || 'Item') + '</strong>' + qtyPart + '</div>'
      + '</div>';
  }

  function showCartNotification(itemData) {
    if (window.theme && theme.ensPersonalisationQuantity) theme.ensPersonalisationQuantity.added(itemData);
    var now = Date.now();
    if (now - _lastNotify < DEDUP_MS) return;
    _lastNotify = now;

    if (_isDrawerMode()) return; // drawer opening is the feedback

    var title  = (itemData && (itemData.product_title || itemData.title)) || 'Item added';
    var imgUrl = (itemData && itemData.image) || '';
    var qty    = (itemData && itemData.quantity) || 1;
    var msg    = _buildMessage(title, imgUrl, qty);

    if (typeof $.growl !== 'undefined') {
      $.growl.notice({ title: 'Added to cart', message: msg });
    } else if (typeof theme !== 'undefined' && theme.alert && typeof theme.alert.new === 'function') {
      theme.alert.new('Added to cart!', msg, 3000, 'notice');
    }

    _updateMiniCart();
  }

  /* ── Fetch interceptor (catches Globo AJAX + native form fetch) ── */

  var _originalFetch = window.fetch;

  window.fetch = function () {
    var args   = Array.prototype.slice.call(arguments);
    var url    = typeof args[0] === 'string' ? args[0]
                 : (args[0] && typeof args[0].url === 'string' ? args[0].url : '');
    var isCartAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;

    var promise = _originalFetch.apply(window, args);

    if (isCartAdd) {
      promise.then(function (response) {
        if (response && response.ok) {
          response.clone().json().then(function (data) {
            showCartNotification(data);
          }).catch(function () {
            showCartNotification(null);
          });
        }
      }).catch(function () {});
    }

    return promise;
  };

  /* ── XHR interceptor (catches Shopify.addItem jQuery/Ajax used by quick-add) ── */

  var _XHROpen = XMLHttpRequest.prototype.open;
  var _XHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._ensUrl = url;
    _XHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr._ensUrl && xhr._ensUrl.indexOf('/cart/add') !== -1) {
      var _onload = xhr.onload;
      xhr.onload = function (ev) {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var data = JSON.parse(xhr.responseText);
            showCartNotification(data);
          } catch (e) {
            showCartNotification(null);
          }
        }
        if (typeof _onload === 'function') _onload.call(this, ev);
      };

      var _onreadystatechange = xhr.onreadystatechange;
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 300) {
          try {
            var data = JSON.parse(xhr.responseText);
            showCartNotification(data);
          } catch (e) {
            showCartNotification(null);
          }
        }
        if (typeof _onreadystatechange === 'function') _onreadystatechange.call(this);
      };
    }
    _XHRSend.apply(this, arguments);
  };

})();
